import { render, staticRenderFns } from "./ModalRating.vue?vue&type=template&id=996b535e&"
import script from "./ModalRating.vue?vue&type=script&lang=js&"
export * from "./ModalRating.vue?vue&type=script&lang=js&"
import style0 from "./ModalRating.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports